// src/rms/utils/idempotency.js

export function generateIdempotencyKey(prefix = 'rms') {
  const rand = Math.random().toString(36).slice(2);
  const ts = Date.now().toString(36);
  return `${prefix}_${ts}_${rand}`;
}


